export default __webpack_public_path__ + "static/media/Leggings of the Lector.7dd5e934.jpg";